module.exports = __webpack_public_path__ + "media/images/webdesign/hg-10e70f98ed4d42e52405e447e3bfeb26.jpg";